<template>
  <div id="app">
  	<!-- <router-view/> -->
    <keep-alive><router-view/></keep-alive>
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue